import { Component } from "react"

/**
 * alertUnsavedHOC is a higher-order component that adds listeners to watch
 * for changes to the form on the page and alerts the user if they are
 * leaving without submitting their changes.
 *
 * When using, turbolinks must be disabled for the entire page, not just the
 * component, or else navigation links etc will not be handled correctly. If
 * you're using Rails views and react_component set @body_turbolinks = false.
 *
 * @function alertUnsavedHOC
 * @param WrappedComponent the component to be augmented by the HOC
 */
export default function alertUnsavedHOC(WrappedComponent) {
  return class alertUnsaved extends Component {
    state = {
      changed: false,
    }

    handleChange = () => {
      this.setState({ changed: true })
    }

    handleSubmit = () => {
      this.setState({ changed: false })
    }

    handleBeforeUnload = event => {
      if (this.state.changed == true) {
        event.returnValue =
          "You have unsaved changes. Do you want to leave this page and discard your changes?"
      }
    }

    componentDidMount() {
      this.wrappedElement.querySelectorAll("input").forEach(input => {
        input.addEventListener("change", this.handleChange, {
          once: true,
        })
      })
      this.wrappedElement
        .querySelector("form")
        .addEventListener("submit", this.handleSubmit, { once: true })
      window.addEventListener("beforeunload", this.handleBeforeUnload, {
        once: true,
      })
    }

    componentWillUnmount() {
      this.wrappedElement.querySelectorAll("input").forEach(input => {
        input.removeEventListener("change", this.handleChange, {
          once: true,
        })
      })
      this.wrappedElement
        .querySelector("form")
        .removeEventListener("submit", this.handleSubmit, { once: true })
      window.removeEventListener("beforeunload", this.handleBeforeUnload, {
        once: true,
      })
    }

    render() {
      return (
        <div
          ref={ref => (this.wrappedElement = ref)}
          className="alert-unsaved-hoc"
        >
          <WrappedComponent {...this.props} />
        </div>
      )
    }
  }
}
